<template>
  <div class="sales-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              CDC (Customer Data)
              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'cdcDetails' })"
              >
                Cdc Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div :key="data.id" class="col" v-for="data in weekData">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                Day {{ data.day }}/{{ data.month }}
                <small>Week {{ data.week_num }}</small>
              </h3>

              <div class="figure">
                {{ data.number }}
                <small>CDC</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Highest CDC Collected
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getCdcChart"
                  v-model="chartDateDropdown"
                >
                  <option value="year">YEAR</option>
                  <option value="month">MONTH</option>
                  <option value="week">WEEK</option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="chartData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getCdcArea"
                  v-model="areaDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in areaTopFiveData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}%</dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Least 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in areaLeastFiveData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}%</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Favourite Product Category
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getCdcCategory"
                  v-model="categoryDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in categoryData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">
                    {{ data.category.name }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Age Group
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getCdcAge"
                  v-model="ageDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in ageData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">
                    {{ data.age_range }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-loader v-show="isLoading"></app-loader>
    </div>
  </div>
</template>

<style scoped>
.sales-summary .top-navbar .top-navbar-right button:first-child {
  margin-right: 20px;
}
</style>

<script>
import {
  getDashboardDate,
  checkPermission,
  getCdcSummary,
  getCdcSummaryByCategoryType
} from "../api";
import { getProj } from "../helpers";

import LineChart from "./chart/LineChart.vue";
import Loader from "./Loader";

export default {
  components: {
    appLineChart: LineChart,
    appLoader: Loader
  },
  data() {
    const moment = require("moment");
    const startOfMonth = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    const thisMonday = moment()
      .day("Monday")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      restrictViewUsers: false,
      monthlyDateFilter: [],
      weeklyDateFilter: [],
      projectId: getProj()["projId"],
      isLoading: true,
      weekData: "",
      chartDateDropdown: "month",
      chartData: {},
      chartOption: process.env.VUE_APP_CHART,
      areaTopFiveData: "",
      areaLeastFiveData: "",
      areaDateDropdown: startOfMonth,
      categoryData: "",
      categoryDateDropdown: startOfMonth,
      ageData: "",
      ageDateDropdown: thisMonday
    };
  },
  async mounted() {
    this.restrictViewUsers = await this.checkPermission("restrict users");
    await this.getDate();
    await this.getCdcSummary();
    await this.getCdcChart();
    await this.getCdcArea();
    await this.getCdcCategory();
    await this.getCdcAge();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const monthParams = { dateType: "month" };
        const weekParams = { dateType: "week" };
        const result = await Promise.all([
          getDashboardDate(monthParams),
          getDashboardDate(weekParams)
        ]);
        this.monthlyDateFilter = result[0].data.data.dates;
        this.weeklyDateFilter = result[1].data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async checkPermission(permission) {
      try {
        const result = await checkPermission({ permission: permission });
        return result.data.data;
      } catch (err) {
        return false;
      }
    },
    async getCdcSummary() {
      try {
        let result = await getCdcSummary({
          projectId: this.projectId,
          dateType: "day"
        });
        this.weekData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcChart() {
      try {
        let result = await getCdcSummary({
          projectId: this.projectId,
          dateType: this.chartDateDropdown
        });
        this.chartData = result.data.data.statistics;
        this.filterChart();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcArea() {
      try {
        let result = await getCdcSummaryByCategoryType({
          projectId: this.projectId,
          category: "area",
          dateType: this.areaDateDropdown
        });
        this.areaTopFiveData = result.data.data.statistics.topfive;
        this.areaLeastFiveData = result.data.data.statistics.worstFive;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcCategory() {
      try {
        let result = await getCdcSummaryByCategoryType({
          projectId: this.projectId,
          category: "category",
          dateType: this.categoryDateDropdown
        });
        this.categoryData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getCdcAge() {
      try {
        let result = await getCdcSummaryByCategoryType({
          projectId: this.projectId,
          category: "age",
          dateType: this.ageDateDropdown
        });
        this.ageData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    filterChart() {
      let labels = [];
      let data = [];

      this.chartData.forEach(item => {
        if (this.chartDateDropdown == "week") labels.push(item.week_num);
        if (this.chartDateDropdown == "month") labels.push(item.month);
        if (this.chartDateDropdown == "year") labels.push(item.year);
        data.push(item.number);
      });

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: "Total CDC",
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#FDCD08",
            borderWidth: 2,
            lineTension: 0,
            data: data
          }
        ]
      };
    }
  }
};
</script>
